import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { orpc, rpcClient } from '@/api/rpc/client';
import { useToast } from '@/context/ToastContext';
import type { ListSampleEmailsInput, SetSampleEmailLabelInput } from '@erp/rpc';

/** Paginated, org-scoped list of labeled 849 sample emails (with drift). */
export function useSampleEmails(input: ListSampleEmailsInput) {
  return useQuery(orpc.shipAndDebit.sampleEmails.list.queryOptions({ input }));
}

/** Set the is-849 label (and optional notes) on a sample; invalidates the list. */
export function useSetSampleEmailLabel() {
  const queryClient = useQueryClient();
  const { showToast } = useToast();
  return useMutation({
    mutationFn: (input: SetSampleEmailLabelInput) =>
      rpcClient.shipAndDebit.sampleEmails.setLabel(input),
    onSuccess: () => {
      showToast({
        title: 'Saved',
        message: 'Sample label updated',
        color: 'success',
      });
      void queryClient.invalidateQueries({
        queryKey: orpc.shipAndDebit.sampleEmails.list.key(),
      });
    },
    onError: (error: Error) =>
      showToast({ title: 'Error', message: error.message, color: 'error' }),
  });
}
